export const HOME = '/';
export const MAP = '/map';
export const LOGIN = '/login';
export const LOGIN_ADMIN = '/login-admin/:id';
export const LOGOUT = '/logout';
export const REGISTRATION = '/registration';
export const FORGOT_PASSWORD = '/forgot-password';
export const DOCUMENT_CONFIRMATION = '/document-confirmation';
export const SEARCH = '/search';
export const SEARCH2 = '/search2';
export const EDIT_PROFILE2 = '/edit-profile2/:id';
export const MESSAGES = '/messages';
export const MESSAGES_ID = '/messages/:id';
export const POSTS = '/posts';
export const NEW_POST = '/new-post';
export const COMMENTS = '/posts/:id';
export const NOTIFICATIONS = '/notifications';
export const FAVORITES = '/favorites';
export const MY_PROFILE = '/profile';
export const PROFILE = '/profile/:id';
export const SETTINGS = '/settings';
export const VERIFICATION = '/settings/verification';
export const CHANGE_PASSWORD = '/change-password';
export const VEHICLES = '/vehicles';
export const VEHICLE_REGISTRATION = '/vehicle-registration';
export const EDIT_VEHICLE = '/edit-vehicle/:id';
export const MEMBERSHIP = '/membership/:activeTab';
export const HISTORY = '/history';
export const ABOUT = '/about';
export const PAYMENT_SUCCESS = '/payment/success';
export const PAYMENT_ERROR = '/payment/error';
export const PRIVACY_POLICY = '/privacy-policy';
export const PLAN_DETAILS = '/events/:id';
export const START_WASH = '/start-wash/:id';
export const WASHES = '/washes';
export const WASH_DETAILS = '/washes/:id';
export const SUBSCRIPTION_DETAILS = '/subscriptions/:id';
export const DASHBOARD = '/dashboard/*';
export const DASHBOARD_TICKETS = '/dashboard/:eventId/tickets';
export const DASHBOARD_TICKETS_FORM_NEW = '/dashboard/:eventId/tickets/new';
export const DASHBOARD_TICKETS_FORM_EDIT = '/dashboard/:eventId/tickets/:id';
export const DASHBOARD_TICKET_TYPE = '/dashboard/:eventId/ticket-types';
export const DASHBOARD_TICKET_TYPE_FORM_NEW = '/dashboard/:eventId/ticket-types/new';
export const DASHBOARD_TICKET_TYPE_FORM_EDIT = '/dashboard/:eventId/ticket-types/:id';
export const DASHBOARD_SETTINGS = '/dashboard/:eventId/settings';
export const APPLE_PAY_PAGE = '/payment/apple';
